import { ApiClientService, EntityApiService, RequestConfig } from '@dfl/react-security';
import { ANALYTIC_OPS_METRIC, ANALYTICS_BUSINESS_METRIC } from 'modules/dashboard/interfaces/IAnalyticPaymentSummary';
import { mutateFilter } from 'utils/custom-filters';

class AnalyticPaymentService extends EntityApiService<any> {
  searchAnalyticOps = (metric: ANALYTIC_OPS_METRIC, params?: any, config?: RequestConfig) => {
    return this.handleResponse(ApiClientService.post(this.getPath(`/payment-ops-reports/${metric}`), params, config));
  };

  searchAnalyticBusiness = (metric: ANALYTICS_BUSINESS_METRIC, params?: any, config?: RequestConfig) => {
    params.filters = mutateFilter(params.filters, 'day', 'createdAt');
    return this.handleResponse(ApiClientService.post(this.getPath(`/payment-biz-reports/${metric}`), params, config));
  };
}

export default new AnalyticPaymentService('/ms-pay/api/v1');
